import { render, staticRenderFns } from "./MedicineDispatchDetail.vue?vue&type=template&id=00ba86fe&scoped=true"
import script from "./MedicineDispatchDetail.vue?vue&type=script&lang=js"
export * from "./MedicineDispatchDetail.vue?vue&type=script&lang=js"
import style0 from "./MedicineDispatchDetail.vue?vue&type=style&index=0&id=00ba86fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ba86fe",
  null
  
)

export default component.exports